import { render, staticRenderFns } from "./EngravingPleat.vue?vue&type=template&id=6b1e38e1&scoped=true&"
import script from "./EngravingPleat.vue?vue&type=script&lang=js&"
export * from "./EngravingPleat.vue?vue&type=script&lang=js&"
import style0 from "./EngravingPleat.vue?vue&type=style&index=0&id=6b1e38e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e38e1",
  null
  
)

export default component.exports